var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { isLoading, isRejected } from "../../../../helpers";
import { Loader, FreeHtml } from "sb-resp-ui";
import { Remove } from "./../Remove";
var baseClass = "rj-yourbet__message";
var Message = /** @class */ (function (_super) {
    __extends(Message, _super);
    function Message() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Message.prototype.render = function () {
        var _a = this.props, modifier = _a.modifier, label = _a.label, type = _a.type, handler = _a.handler;
        var cls = baseClass + (modifier ? " " + baseClass + "--" + modifier : "");
        return (React.createElement("div", { className: cls, "data-uat": "your-bet-status-" + modifier },
            React.createElement("span", { className: "rj-yourbet__message-text", "data-uat": "your-bet-message-text" },
                React.createElement(FreeHtml, { html: label })),
            isLoading(type) && React.createElement(Loader, null),
            isRejected(type) && handler &&
                React.createElement(Remove, { modifier: "close", "data-uat": "yourbet-message-close", icon: "i-12 i-o-yourbet-close", handler: handler })));
    };
    return Message;
}(React.Component));
export { Message };
//# sourceMappingURL=Message.js.map